{
    "v": "4.8.0",
    "meta": { "g": "LottieFiles AE 3.3.6", "a": "", "k": "", "d": "", "tc": "" },
    "fr": 25,
    "ip": 0,
    "op": 48,
    "w": 500,
    "h": 500,
    "nm": "41 society",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 3,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 16, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 48,
            "st": -3,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Graphic",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.43], "y": [1] }, "o": { "x": [0.57], "y": [0] }, "t": 0, "s": [0] },
                        { "t": 48, "s": [90] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [221.3, 221.3, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 21,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -41.182],
                                                            [41.182, 0],
                                                            [0, 41.182],
                                                            [-41.182, 0]
                                                        ],
                                                        "o": [
                                                            [0, 41.182],
                                                            [-41.182, 0],
                                                            [0, -41.182],
                                                            [41.182, 0]
                                                        ],
                                                        "v": [
                                                            [74.566, 0],
                                                            [-0.001, 74.567],
                                                            [-74.566, 0],
                                                            [-0.001, -74.567]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 33,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -47.367],
                                                            [47.367, 0],
                                                            [0, 47.367],
                                                            [-47.367, 0]
                                                        ],
                                                        "o": [
                                                            [0, 47.367],
                                                            [-47.367, 0],
                                                            [0, -47.367],
                                                            [47.367, 0]
                                                        ],
                                                        "v": [
                                                            [85.766, 0],
                                                            [-0.001, 85.767],
                                                            [-85.766, 0],
                                                            [-0.001, -85.767]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 46,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -41.182],
                                                            [41.182, 0],
                                                            [0, 41.182],
                                                            [-41.182, 0]
                                                        ],
                                                        "o": [
                                                            [0, 41.182],
                                                            [-41.182, 0],
                                                            [0, -41.182],
                                                            [41.182, 0]
                                                        ],
                                                        "v": [
                                                            [74.566, 0],
                                                            [-0.001, 74.567],
                                                            [-74.566, 0],
                                                            [-0.001, -74.567]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [114.566, 328.034], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 21,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-12.261, 0],
                                                            [0, 0],
                                                            [-1.768, -11.727]
                                                        ],
                                                        "o": [
                                                            [1.719, -11.784],
                                                            [0, 0],
                                                            [12.22, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-55.578, 10.379],
                                                            [-31.462, -10.379],
                                                            [31.463, -10.379],
                                                            [55.578, 10.376]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 33,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-14.103, 0],
                                                            [0, 0],
                                                            [-2.034, -13.488]
                                                        ],
                                                        "o": [
                                                            [1.977, -13.554],
                                                            [0, 0],
                                                            [14.055, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-63.926, 17.846],
                                                            [-36.188, -6.03],
                                                            [36.189, -6.03],
                                                            [63.925, 17.842]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 46,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-12.261, 0],
                                                            [0, 0],
                                                            [-1.768, -11.727]
                                                        ],
                                                        "o": [
                                                            [1.719, -11.784],
                                                            [0, 0],
                                                            [12.22, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-55.578, 10.379],
                                                            [-31.462, -10.379],
                                                            [31.463, -10.379],
                                                            [55.578, 10.376]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3,
                                        "x": ""
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [114.566, 367.367], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 21,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -15.087],
                                                            [15.087, 0],
                                                            [0, 15.087],
                                                            [-15.087, 0]
                                                        ],
                                                        "o": [
                                                            [0, 15.087],
                                                            [-15.087, 0],
                                                            [0, -15.087],
                                                            [15.087, 0]
                                                        ],
                                                        "v": [
                                                            [27.317, 0.024],
                                                            [0, 27.293],
                                                            [-27.317, 0.024],
                                                            [0, -27.293]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 33,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -17.353],
                                                            [17.353, 0],
                                                            [0, 17.353],
                                                            [-17.353, 0]
                                                        ],
                                                        "o": [
                                                            [0, 17.353],
                                                            [-17.353, 0],
                                                            [0, -17.353],
                                                            [17.353, 0]
                                                        ],
                                                        "v": [
                                                            [31.62, -22.223],
                                                            [0.2, 9.142],
                                                            [-31.22, -22.223],
                                                            [0.2, -53.643]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 46,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -15.087],
                                                            [15.087, 0],
                                                            [0, 15.087],
                                                            [-15.087, 0]
                                                        ],
                                                        "o": [
                                                            [0, 15.087],
                                                            [-15.087, 0],
                                                            [0, -15.087],
                                                            [15.087, 0]
                                                        ],
                                                        "v": [
                                                            [27.317, 0.024],
                                                            [0, 27.293],
                                                            [-27.317, 0.024],
                                                            [0, -27.293]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3,
                                        "x": ""
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [114.566, 329.695], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 3",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [114.566, 328.034], "ix": 2 },
                            "a": { "a": 0, "k": [114.566, 328.034], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.43], "y": [1] },
                                        "o": { "x": [0.57], "y": [0] },
                                        "t": 0,
                                        "s": [0]
                                    },
                                    { "t": 48, "s": [-90] }
                                ],
                                "ix": 6
                            },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 18",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.43, "y": 1 },
                                        "o": { "x": 0.57, "y": 0 },
                                        "t": 8,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-17.891, 17.891],
                                                    [17.892, -17.891]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.43, "y": 1 },
                                        "o": { "x": 0.57, "y": 0 },
                                        "t": 20,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-17.891, 17.891],
                                                    [9.617, -9.617]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 33,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-17.891, 17.891],
                                                    [17.892, -17.891]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [257.405, 185.195], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.43, "y": 1 },
                                        "o": { "x": 0.57, "y": 0 },
                                        "t": 16,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-17.879, -17.879],
                                                    [17.879, 17.879]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.43, "y": 1 },
                                        "o": { "x": 0.57, "y": 0 },
                                        "t": 27,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-17.879, -17.879],
                                                    [9.954, 9.954]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 39,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-17.879, -17.879],
                                                    [17.879, 17.879]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [257.392, 257.393], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.43, "y": 1 },
                                        "o": { "x": 0.57, "y": 0 },
                                        "t": 21,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [17.895, -17.895],
                                                    [-17.895, 17.895]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.43, "y": 1 },
                                        "o": { "x": 0.57, "y": 0 },
                                        "t": 33,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [17.895, -17.895],
                                                    [-9.975, 9.975]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 46,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [17.895, -17.895],
                                                    [-17.895, 17.895]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [185.192, 257.408], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 6",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.43, "y": 1 },
                                        "o": { "x": 0.57, "y": 0 },
                                        "t": 1,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [17.9, 17.899],
                                                    [-17.9, -17.899]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.43, "y": 1 },
                                        "o": { "x": 0.57, "y": 0 },
                                        "t": 15,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [17.9, 17.899],
                                                    [-10.712, -10.712]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 28,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [17.9, 17.899],
                                                    [-17.9, -17.899]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [185.187, 185.187], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 7",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [10.059, -10.059],
                                        [10.059, 10.059],
                                        [-10.059, 10.059],
                                        [-10.059, -10.059]
                                    ],
                                    "o": [
                                        [-10.059, 10.059],
                                        [-10.059, -10.059],
                                        [10.059, -10.059],
                                        [10.059, 10.059]
                                    ],
                                    "v": [
                                        [18.214, 18.213],
                                        [-18.213, 18.213],
                                        [-18.213, -18.213],
                                        [18.214, -18.213]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [221.3, 221.3], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 8",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 16,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -41.182],
                                                            [41.182, 0],
                                                            [0, 41.182],
                                                            [-41.182, 0]
                                                        ],
                                                        "o": [
                                                            [0, 41.182],
                                                            [-41.182, 0],
                                                            [0, -41.182],
                                                            [41.182, 0]
                                                        ],
                                                        "v": [
                                                            [74.566, 0],
                                                            [-0.001, 74.567],
                                                            [-74.567, 0],
                                                            [-0.001, -74.567]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 27,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -47.367],
                                                            [47.367, 0],
                                                            [0, 47.367],
                                                            [-47.367, 0]
                                                        ],
                                                        "o": [
                                                            [0, 47.367],
                                                            [-47.367, 0],
                                                            [0, -47.367],
                                                            [47.367, 0]
                                                        ],
                                                        "v": [
                                                            [85.766, 0],
                                                            [-0.001, 85.767],
                                                            [-85.766, 0],
                                                            [-0.001, -85.767]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 39,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -41.182],
                                                            [41.182, 0],
                                                            [0, 41.182],
                                                            [-41.182, 0]
                                                        ],
                                                        "o": [
                                                            [0, 41.182],
                                                            [-41.182, 0],
                                                            [0, -41.182],
                                                            [41.182, 0]
                                                        ],
                                                        "v": [
                                                            [74.566, 0],
                                                            [-0.001, 74.567],
                                                            [-74.567, 0],
                                                            [-0.001, -74.567]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [328.033, 328.034], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 9",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 16,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-12.261, 0],
                                                            [0, 0],
                                                            [-1.769, -11.727]
                                                        ],
                                                        "o": [
                                                            [1.719, -11.784],
                                                            [0, 0],
                                                            [12.22, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-55.578, 10.379],
                                                            [-31.462, -10.379],
                                                            [31.463, -10.379],
                                                            [55.578, 10.376]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 27,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-14.103, 0],
                                                            [0, 0],
                                                            [-2.035, -13.488]
                                                        ],
                                                        "o": [
                                                            [1.977, -13.554],
                                                            [0, 0],
                                                            [14.055, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-63.926, 17.846],
                                                            [-36.188, -6.03],
                                                            [36.188, -6.03],
                                                            [63.926, 17.842]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 39,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-12.261, 0],
                                                            [0, 0],
                                                            [-1.769, -11.727]
                                                        ],
                                                        "o": [
                                                            [1.719, -11.784],
                                                            [0, 0],
                                                            [12.22, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-55.578, 10.379],
                                                            [-31.462, -10.379],
                                                            [31.463, -10.379],
                                                            [55.578, 10.376]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3,
                                        "x": ""
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [328.033, 367.367], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 10",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 16,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -15.087],
                                                            [15.087, 0],
                                                            [0, 15.087],
                                                            [-15.087, 0]
                                                        ],
                                                        "o": [
                                                            [0, 15.087],
                                                            [-15.087, 0],
                                                            [0, -15.087],
                                                            [15.087, 0]
                                                        ],
                                                        "v": [
                                                            [27.317, 0.024],
                                                            [0, 27.293],
                                                            [-27.317, 0.024],
                                                            [0, -27.293]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 27,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -17.353],
                                                            [17.353, 0],
                                                            [0, 17.353],
                                                            [-17.353, 0]
                                                        ],
                                                        "o": [
                                                            [0, 17.353],
                                                            [-17.353, 0],
                                                            [0, -17.353],
                                                            [17.353, 0]
                                                        ],
                                                        "v": [
                                                            [31.62, -20.223],
                                                            [0.2, 11.142],
                                                            [-31.22, -20.223],
                                                            [0.2, -51.643]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 39,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -15.087],
                                                            [15.087, 0],
                                                            [0, 15.087],
                                                            [-15.087, 0]
                                                        ],
                                                        "o": [
                                                            [0, 15.087],
                                                            [-15.087, 0],
                                                            [0, -15.087],
                                                            [15.087, 0]
                                                        ],
                                                        "v": [
                                                            [27.317, 0.024],
                                                            [0, 27.293],
                                                            [-27.317, 0.024],
                                                            [0, -27.293]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3,
                                        "x": ""
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [328.033, 329.695], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 11",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [328.033, 328.034], "ix": 2 },
                            "a": { "a": 0, "k": [328.033, 328.034], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.43], "y": [1] },
                                        "o": { "x": [0.57], "y": [0] },
                                        "t": 0,
                                        "s": [0]
                                    },
                                    { "t": 48, "s": [-90] }
                                ],
                                "ix": 6
                            },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 19",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 7,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 8,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -41.182],
                                                            [41.182, 0],
                                                            [0, 41.182],
                                                            [-41.182, 0]
                                                        ],
                                                        "o": [
                                                            [0, 41.182],
                                                            [-41.182, 0],
                                                            [0, -41.182],
                                                            [41.182, 0]
                                                        ],
                                                        "v": [
                                                            [74.566, 0],
                                                            [-0.001, 74.567],
                                                            [-74.567, 0],
                                                            [-0.001, -74.567]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 20,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -47.644],
                                                            [47.644, 0],
                                                            [0, 47.644],
                                                            [-47.644, 0]
                                                        ],
                                                        "o": [
                                                            [0, 47.644],
                                                            [-47.644, 0],
                                                            [0, -47.644],
                                                            [47.644, 0]
                                                        ],
                                                        "v": [
                                                            [86.267, 0],
                                                            [-0.001, 86.267],
                                                            [-86.267, 0],
                                                            [-0.001, -86.267]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 33,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -41.182],
                                                            [41.182, 0],
                                                            [0, 41.182],
                                                            [-41.182, 0]
                                                        ],
                                                        "o": [
                                                            [0, 41.182],
                                                            [-41.182, 0],
                                                            [0, -41.182],
                                                            [41.182, 0]
                                                        ],
                                                        "v": [
                                                            [74.566, 0],
                                                            [-0.001, 74.567],
                                                            [-74.567, 0],
                                                            [-0.001, -74.567]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [328.033, 114.567], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 12",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 8,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-12.261, 0],
                                                            [0, 0],
                                                            [-1.769, -11.727]
                                                        ],
                                                        "o": [
                                                            [1.719, -11.784],
                                                            [0, 0],
                                                            [12.22, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-55.578, 10.379],
                                                            [-31.462, -10.379],
                                                            [31.463, -10.379],
                                                            [55.578, 10.376]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 20,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-14.185, 0],
                                                            [0, 0],
                                                            [-2.047, -13.567]
                                                        ],
                                                        "o": [
                                                            [1.989, -13.633],
                                                            [0, 0],
                                                            [14.137, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-64.299, 18.179],
                                                            [-36.399, -5.836],
                                                            [36.399, -5.836],
                                                            [64.299, 18.176]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 33,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-12.261, 0],
                                                            [0, 0],
                                                            [-1.769, -11.727]
                                                        ],
                                                        "o": [
                                                            [1.719, -11.784],
                                                            [0, 0],
                                                            [12.22, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-55.578, 10.379],
                                                            [-31.462, -10.379],
                                                            [31.463, -10.379],
                                                            [55.578, 10.376]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3,
                                        "x": ""
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [328.033, 153.9], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 13",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 8,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -15.087],
                                                            [15.087, 0],
                                                            [0, 15.087],
                                                            [-15.087, 0]
                                                        ],
                                                        "o": [
                                                            [0, 15.087],
                                                            [-15.087, 0],
                                                            [0, -15.087],
                                                            [15.087, 0]
                                                        ],
                                                        "v": [
                                                            [27.317, 0.024],
                                                            [0, 27.293],
                                                            [-27.317, 0.024],
                                                            [0, -27.293]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 20,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -17.454],
                                                            [17.454, 0],
                                                            [0, 17.454],
                                                            [-17.454, 0]
                                                        ],
                                                        "o": [
                                                            [0, 17.454],
                                                            [-17.454, 0],
                                                            [0, -17.454],
                                                            [17.454, 0]
                                                        ],
                                                        "v": [
                                                            [31.704, -23.212],
                                                            [0.1, 8.336],
                                                            [-31.503, -23.212],
                                                            [0.1, -54.815]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 33,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -15.087],
                                                            [15.087, 0],
                                                            [0, 15.087],
                                                            [-15.087, 0]
                                                        ],
                                                        "o": [
                                                            [0, 15.087],
                                                            [-15.087, 0],
                                                            [0, -15.087],
                                                            [15.087, 0]
                                                        ],
                                                        "v": [
                                                            [27.317, 0.024],
                                                            [0, 27.293],
                                                            [-27.317, 0.024],
                                                            [0, -27.293]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3,
                                        "x": ""
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [328.033, 116.228], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 14",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [328.033, 114.567], "ix": 2 },
                            "a": { "a": 0, "k": [328.033, 114.567], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.43], "y": [1] },
                                        "o": { "x": [0.57], "y": [0] },
                                        "t": 0,
                                        "s": [0]
                                    },
                                    { "t": 48, "s": [-90] }
                                ],
                                "ix": 6
                            },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 20",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 8,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 1,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -41.182],
                                                            [41.182, 0],
                                                            [0, 41.182],
                                                            [-41.182, 0]
                                                        ],
                                                        "o": [
                                                            [0, 41.182],
                                                            [-41.182, 0],
                                                            [0, -41.182],
                                                            [41.182, 0]
                                                        ],
                                                        "v": [
                                                            [74.566, 0],
                                                            [-0.001, 74.567],
                                                            [-74.566, 0],
                                                            [-0.001, -74.567]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 15,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -46.797],
                                                            [46.797, 0],
                                                            [0, 46.797],
                                                            [-46.797, 0]
                                                        ],
                                                        "o": [
                                                            [0, 46.797],
                                                            [-46.797, 0],
                                                            [0, -46.797],
                                                            [46.797, 0]
                                                        ],
                                                        "v": [
                                                            [84.733, 0],
                                                            [-0.001, 84.733],
                                                            [-84.733, 0],
                                                            [-0.001, -84.733]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 28,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -41.182],
                                                            [41.182, 0],
                                                            [0, 41.182],
                                                            [-41.182, 0]
                                                        ],
                                                        "o": [
                                                            [0, 41.182],
                                                            [-41.182, 0],
                                                            [0, -41.182],
                                                            [41.182, 0]
                                                        ],
                                                        "v": [
                                                            [74.566, 0],
                                                            [-0.001, 74.567],
                                                            [-74.566, 0],
                                                            [-0.001, -74.567]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [114.566, 114.567], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 15",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 1,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-12.261, 0],
                                                            [0, 0],
                                                            [-1.768, -11.727]
                                                        ],
                                                        "o": [
                                                            [1.719, -11.784],
                                                            [0, 0],
                                                            [12.22, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-55.578, 10.379],
                                                            [-31.462, -10.379],
                                                            [31.463, -10.379],
                                                            [55.578, 10.376]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 15,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-13.933, 0],
                                                            [0, 0],
                                                            [-2.009, -13.326]
                                                        ],
                                                        "o": [
                                                            [1.953, -13.391],
                                                            [0, 0],
                                                            [13.886, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-63.155, 17.157],
                                                            [-35.752, -6.431],
                                                            [35.753, -6.431],
                                                            [63.155, 17.153]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 28,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [-12.261, 0],
                                                            [0, 0],
                                                            [-1.768, -11.727]
                                                        ],
                                                        "o": [
                                                            [1.719, -11.784],
                                                            [0, 0],
                                                            [12.22, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-55.578, 10.379],
                                                            [-31.462, -10.379],
                                                            [31.463, -10.379],
                                                            [55.578, 10.376]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3,
                                        "x": ""
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [114.566, 153.9], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 16",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 1,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -15.087],
                                                            [15.087, 0],
                                                            [0, 15.087],
                                                            [-15.087, 0]
                                                        ],
                                                        "o": [
                                                            [0, 15.087],
                                                            [-15.087, 0],
                                                            [0, -15.087],
                                                            [15.087, 0]
                                                        ],
                                                        "v": [
                                                            [27.317, 0.024],
                                                            [0, 27.293],
                                                            [-27.317, 0.024],
                                                            [0, -27.293]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.43, "y": 1 },
                                                "o": { "x": 0.57, "y": 0 },
                                                "t": 15,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -17.144],
                                                            [17.144, 0],
                                                            [0, 17.144],
                                                            [-17.144, 0]
                                                        ],
                                                        "o": [
                                                            [0, 17.144],
                                                            [-17.144, 0],
                                                            [0, -17.144],
                                                            [17.144, 0]
                                                        ],
                                                        "v": [
                                                            [31.242, -22.746],
                                                            [0.2, 8.241],
                                                            [-30.841, -22.746],
                                                            [0.2, -53.788]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 28,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, -15.087],
                                                            [15.087, 0],
                                                            [0, 15.087],
                                                            [-15.087, 0]
                                                        ],
                                                        "o": [
                                                            [0, 15.087],
                                                            [-15.087, 0],
                                                            [0, -15.087],
                                                            [15.087, 0]
                                                        ],
                                                        "v": [
                                                            [27.317, 0.024],
                                                            [0, 27.293],
                                                            [-27.317, 0.024],
                                                            [0, -27.293]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                        "ix": 3,
                                        "x": ""
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 16,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [114.566, 116.228], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 17",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [114.566, 114.567], "ix": 2 },
                            "a": { "a": 0, "k": [114.566, 114.567], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.43], "y": [1] },
                                        "o": { "x": [0.57], "y": [0] },
                                        "t": 0,
                                        "s": [0]
                                    },
                                    { "t": 48, "s": [-90] }
                                ],
                                "ix": 6
                            },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 21",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 9,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 48,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 48,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
